import { createRootRoute, Outlet } from '@tanstack/react-router';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ErrorBoundary from '../components/ErrorBoundary';
import { useScrollSection } from '../hooks/useScrollSection';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const activeSection = useScrollSection(100);

  return (
    <ErrorBoundary>
      <Navbar activeSection={activeSection} />
      <main>
        <Outlet />
      </main>
      <Footer />
    </ErrorBoundary>
  );
}

